import React from "react";
import TimelineItem from "./TimelineItem";
import "./Timeline.css";

function Timeline({ items }) {
  return (
    <div className="timeline-container">
      {items.map((item, index) => (
        <TimelineItem key={index} item={item} index={index} />
      ))}
    </div>
  );
}

export default Timeline;
